<template>
  <div class="search">
    <div class="search-inner">
      <div class="firstChild">Blast</div>
      <div class="sequence">
        <el-form ref="form1" :inline="true" :model="sequence_form">
          <el-form-item style="width:100%;" class="firstItem">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Input a FASTA sequence here" v-model="sequence_form.query_sequence"
              style="width:100%;">
            </el-input>
          </el-form-item>
          <el-form-item label="Program" prop="search_method">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.search_method" placeholder="Choose">
              <el-option v-for="(item, index) in methodOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Species" prop="species">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.species" placeholder="Choose">
              <el-option v-for="(item, index) in SpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Database" prop="database">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.database" placeholder="Choose">
              <el-option v-for="item in DatabaseOptions" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="E-value">
            <el-select clearable style="width:200px;" size="large" v-model="sequence_form.evalue" placeholder="Choose">
              <el-option v-for="(item, index) in valueOptions" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <p class="file_p">
          or upload sequence FASTA file
          <a href="javascript:;" class="file">Browse
            <input type="file" name="file" ref="file" @change="handleUpdate($event)" />
          </a>
          <span>{{fileName}}</span>
          <!-- <el-button class="btnSearch"><input type="file" name="file" ref='file' @change="handleUpdate($event)">Browse</el-button> -->
        </p>
        <el-row style="margin: 20px 0px 40px 0;">
          <el-button class="btnSearch" @click="Example('sequence_form')">Example</el-button>
          <el-button class="btnSearch" @click="Search('sequence_form')">Search</el-button>
          <el-button class="btnReset" @click="Reset('sequence_form')">Reset</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
let url = {
  specie_all: "species/specie_all",
  blast_data: "blast/blast_data",
  blast_species_data: "blast/blast_species_data",
  blast_database_data: "blast/blast_database_data",
  blast_evalue: "blast/blast_evalue" // blast value下拉框接口
};
import bus from "../common/bus";
export default {
  data() {
    return {
      sequence_form: {
        search_method: "",
        query_sequence: "",
        database: "",
        species: "",
        evalue: "",
      },
      rules: {
        search_method: [
          { required: true, message: 'Please select', trigger: 'change' }
        ],
        query_sequence: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        database: [
          { required: true, message: 'Please select', trigger: 'change' }
        ],
        species: [
          { required: true, message: 'Please select', trigger: 'change' }
        ]
      },
      methodOptions: ['blastp', 'blastx', 'blastn', 'tblastn', 'tblastx'],
      DatabaseOptions: [
        {
          label: 'lncRNA Sequences',
          value: 'lncRNA'
        },
        {
          label: 'CDS Sequences',
          value: 'cds'
        },
        {
          label: 'Genome Sequences',
          value: 'chromosome'
        },
        {
          label: 'Peptide Sequences',
          value: 'pep'
        },
        {
          label: 'Gene Sequences',
          value: 'gene'
        }
      ],
      SpeciesOptions: [],
      valueOptions: ['1e-20', '1e-10', '1e-5', '0.01', '0.1', '1', '10', '100'],
      file: "",
      fileName: ''
    };
  },
  mounted() {
    this.specie_all()
  },
  methods: {
    Example(param) {
      let params = "";
      if (param == "sequence_form") {
        // this.speciesChange("Arabidopsis_thaliana")
        this.sequence_form = {
          search_method: "blastn",
          query_sequence:
            ">AT1G51370.2\nATGGTGGGTGGCAAGAAGAAAACCAAGATATGTGACAAAGTGTCACATGAGGAAGATAGGATAAGCCAGTTACCGGAACC\nTTTGATATCTGAAATACTTTTTCATCTTTCTACCAAGGACTCTGTCAGAACAAGCGCTTTGTCTACCAAATGGAGATATC",
          database: "cds",
          species: "Arabidopsis_thaliana",
          evalue: "1e-5",
        };
      }
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then((res) => {
        if (res.data.code == 200) {
          this.SpeciesOptions = res.data.data;
          // this.SpeciesOptions.unshift({
          //   label: 'All species',
          //   value: ' '
          // })
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    Search(param) {
      sessionStorage.removeItem("tableParams");
      let params = "";
      let urls = "";
      let urls2 = "";
      let types = 1; // 1,2,3 三种不用的详情表格
      if (param == "sequence_form") {
        params = this.sequence_form;
        urls = url.blast_data;
        types = 3;
      }
      let tableParams = {
        urls: urls,
        urls2: urls2,
        params: params,
        types: types,
      };
      sessionStorage.setItem("tableParams", JSON.stringify(tableParams));
      if (types == 3) {
        this.$refs['form1'].validate((valid) => {
          if (valid) {
            this.getData()
          } else {
            return false;
          }
        });
      } else {
        this.$router.push("/searchList");
      }
    },
    getData() {
      let formData = new FormData()
      formData.append('species', this.sequence_form.species)
      formData.append('database', this.sequence_form.database)
      formData.append('file', this.file)
      formData.append('query_sequence', this.sequence_form.query_sequence)
      formData.append('search_method', this.sequence_form.search_method)
      formData.append('evalue', this.sequence_form.evalue)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      sessionStorage.removeItem("tableParams3");
      this.$axios.post(url.blast_data, formData, config).then(res => {
        if (res.data.code == 200) {
          sessionStorage.setItem("tableParams3", JSON.stringify(res.data.data));
          this.$router.push("/searchList");
        } else {
          this.$message.warning(res.data.msg);
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    Reset(param) {
      if (param == "sequence_form") {
        this.fileName = ''
        this.file = ''
        // this.DatabaseOptions = [];
        // this.SpeciesOptions = [];
        // this.valueOptions = [];
        this.sequence_form = {
          search_method: "",
          query_sequence: "",
          database: "",
          species: "",
          evalue: "",
        }
        this.$refs['form1'].resetFields()
      }
    },
    locationChange(val) {
      this.search_chr(val);
    },
    speciesChange(val) {
      this.DatabaseOptions = [];
      this.sequence_form.database = "";
      this.http.get(url.blast_database_data, { species: val }).then((res) => {
        if (res.data.code == 200) {
          this.DatabaseOptions = res.data.data;
        }
      })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
      this.valueOptions = [];
      this.sequence_form.evalue = "";
      this.http.get(url.blast_evalue, { species: val }).then((res) => {
        if (res.data.code == 200) {
          this.valueOptions = res.data.data;
        }
      })
        .catch((err) => {
          this.$message.warning(err.response.data.error.message);
        });
    },
    handleUpdate(event) {
      if (event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length - 1] != 'fa') {
        this.$message.warning('Please upload .fa file！');
      } else {
        this.fileName = event.target.files[0].name
        this.file = event.target.files[0]
        sessionStorage.setItem("files", JSON.stringify(event.target.files[0]));
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000;
}
ul,
li {
  list-style: none;
}
.search {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-right: 20px;
}
.search .search-inner {
  width: 1240px;
  padding: 0px 20px;
  margin: 0 auto;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
}
.search .search-inner .firstChild {
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  /* line-height: 28px;
  padding-top: 30px; */
  border-bottom: 1px solid rgba(215, 217, 219, 1);
}
.search .search-inner .keyword {
  height: auto;
}
.btnSearch {
  width: 126px;
  height: 40px;
  background: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
}
.btnReset {
  width: 126px;
  height: 40px;
  background: #f1f1f1;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  outline: none;
  border: none;
}
.search .search-inner .sequence {
  height: auto;
  margin-top: 30px;
  /* border-top: 1px solid #8bb644; */
}
.firstItem /deep/ .el-form-item__content {
  width: 100%;
}
.file_p {
  margin-top: 0;
  margin-bottom: 30px;
}
.file_p span {
  display: inline-block;
  padding-left: 30px;
}
.file {
  position: relative;
  display: inline-block;
  background: rgba(139, 182, 68, 1);
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  text-indent: 0;
  line-height: 30px;
  cursor: pointer;
  width: 100px;
  height: 30px;
  text-align: center;
  top: 8px;
  left: 15px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.file:hover {
  color: #fff;
  text-decoration: none;
}
.firstItem {
  flex: 1;
}
.firstItem .el-form-item__content {
  width: 100;
}
</style>
